<template>
  <div class="py-3">
    <div class="bg-white">
      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Seguimiento de Solicitud
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Número de Solicitud de Pedido:
              </p>
              <p class="font-16">
                {{ order?.requestNumber | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Solicitud:
              </p>
              <p class="font-16">
                {{ order?.requestDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Sometido Por:
              </p>
              <p class="font-16">
                {{ order?.submittedBy | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Razón:
              </p>
              <p class="font-16">
                {{ order?.reason | empty }}
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ order?.comment | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información del Libro
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Materia:
              </p>
              <p class="font-16">
                {{ order?.subject | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Grado:
              </p>
              <p class="font-16">
                {{ order?.grade | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Medio de Lectura:
              </p>
              <p class="font-16">
                {{ order?.readingMedium | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Localidad
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Tipo de Localidad:
              </p>
              <p class="font-16">
                {{ locationName | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Centro:
              </p>
              <p class="font-16">
                {{ order?.center | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Municipio:
              </p>
              <p class="font-16">
                {{ order?.municipality | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Escuela:
              </p>
              <p class="font-16">
                {{ order?.school | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inventoryOrderBooksServices from "@/services/api/inventoryOrderBooks.api";
import CustomBalloon from "custom-balloon";
import LocationTypes from "@/utils/constants/inventory/inventoryOrderBookLocationTypes";

export default {
  name: "RequestInfo",
  props: {
    orderDetailId: {
      type: Number
    }
  },
  computed: {
    locationName() {
      return this.order?.bookLocationTypeId != null
        ? this.locationTypes.find(l => l.id == this.order?.bookLocationTypeId)
            .name
        : null;
    }
  },
  components: {
    CustomBalloon
  },
  data() {
    return {
      order: {},
      locationTypes: [
        LocationTypes.CSEE,
        LocationTypes.CENTER,
        LocationTypes.SCHOOL
      ]
    };
  },
  async mounted() {
    await this.getTransferDetails();
  },
  methods: {
    async getTransferDetails() {
      const { data } = await inventoryOrderBooksServices.trackRequestProgress(
        this.orderDetailId
      );
      this.order = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
